import styled from 'styled-components';

import { sizeUp } from '~/theme';
import PlainCard from '~atoms/PlainCard';

export const Container = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: '32rem',
});

export const StoresContainer = styled.div({
  display: 'grid',
  gridTemplateColumns: `repeat(auto-fit, minmax(190rem, 1fr))`,
  gap: sizeUp('15rem', ['md', '30rem']),

  marginBlockStart: '20rem',
});

export const Card = styled(PlainCard)(({ theme }) => ({
  paddingInline: sizeUp('10rem', ['md', '30rem']),
  paddingBlock: sizeUp('10rem', ['md', '20rem']),

  color: theme.page.primary.text,
  fontSize: sizeUp(theme.typography.size11, ['md', theme.typography.size14]),

  p: {
    marginBlock: '11rem 14rem',
  },
}));
